/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardian_Teen_SuccessInputs */

const fr_guardian_teen_success = /** @type {(inputs: Guardian_Teen_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statut ado mis à jour`)
};

/**

* @param {Guardian_Teen_SuccessInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const guardian_teen_success = /** @type {((inputs?: Guardian_Teen_SuccessInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardian_Teen_SuccessInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_guardian_teen_success(inputs)
});